import { string } from 'yup';
import gonda10KWPlantImage from 'src/assets/images/projectsInstalled/gonda-10kw-project-image.jpg';
import Gundasara_Gujarat3_27KWPlantImage from 'src/assets/images/projectsInstalled/MrBhavinKumarKanjbhai-3.27KW-Gundasara_Gujarat-project-image.png';
import Keshod_Gujarat3_24KWPlantImage from 'src/assets/images/projectsInstalled/MrManishKumarMishra-3.24KW-Keshod_Gujarat-project-image.png';
import kushinagar17KWPlantImage from 'src/assets/images/projectsInstalled/kushinager-17kw-project-image.png';
import ceratecAntara70KWPlantImage from 'src/assets/images/projectsInstalled/CeratecAntara-70KW-Yewalewadi-Pune-project-image.jpg';
import bhutDilip4_36KWJamnagarImage from 'src/assets/images/projectsInstalled/bhut_dilip-4.36KW-Jamnagar,Gujarat.png';
import satyamOLeander10KWProjectImage from 'src/assets/images/projectsInstalled/satyam_O_leander-10KW-project-image.jpg';
import prajapatiPradip4_6KWProjectImage from 'src/assets/images/projectsInstalled/prajapatiPradip-4.6KW-Janta-nagar-project-image.png';
import GuptaVishnukumar4_6KWProjectImage from 'src/assets/images/projectsInstalled/GuptaVishnukumar-4.6KW-ahmedabad-project-image.png';
import ParekhSangitaben3_3KWProjectImage from 'src/assets/images/projectsInstalled/ParekhSangitaben-3.3KW-Halol_Panchmahal-Project-Image.jpg';
import SatyachandranVekatraman3KWPojectImage from 'src/assets/images/projectsInstalled/SatyachandranVekatraman-3KW-Vellore-project-image.jpg';
import VedamGranites400KWJaipurProjectImage from 'src/assets/images/projectsInstalled/VedamGranites-400KW_Jaipur-project-image.jpeg';
import AbdulsamadYakub4_5KWProjectImage from 'src/assets/images/projectsInstalled/Abdulsamad_Yakub-4.5KW-project-image.jpeg';
import JindalPolychem61KWProjectImage from 'src/assets/images/projectsInstalled/Jindal_Polychem-61KW-project-image.jpeg';
import JiteshOde9_6KWProjectImage from 'src/assets/images/projectsInstalled/Jitesh_Ode-9.6KW-project-image.jpg';
import RojasaraPrakashGopalbhai3_39KWProjectImage from 'src/assets/images/projectsInstalled/RojasaraPrakashGopalbhai-3.39KW-project-image.jpg';
import RamaniBhavinbhaiDevraj3_85KWProjectImage from 'src/assets/images/projectsInstalled/RamaniBhavinbhaiDevraj-3.85KW-project-image.jpg';
import ChandrajitBhagwatZingare3_3KWProjectImage from 'src/assets/images/projectsInstalled/ChandrajitBhagwatZingare-3.3KW-project-image.jpg';
import Laxmi_Rajasthan5KWProjectImage from 'src/assets/images/projectsInstalled/Laxmi_Rajasthan_5KW.jpg';
import Patanjali_BiharProjectImage1 from 'src/assets/images/projectsInstalled/Patanjali_PoleSolar.jpg';
import Patanjali_BiharProjectImage2 from 'src/assets/images/projectsInstalled/Patanjali_PoleSolar2.jpg';
import Patanjali_BiharProjectImage3 from 'src/assets/images/projectsInstalled/Patanjali_PoleSolar3.jpg';
import Patanjali_BiharProjectImage4 from 'src/assets/images/projectsInstalled/Patanjali_PoleSolar4.jpg';
import Patanjali_BiharProjectImage5 from 'src/assets/images/projectsInstalled/Patanjali_PoleSolar5.jpg';
import RamilabenKantilalPatelProjectImage from 'src/assets/images/projectsInstalled/Ramilaben Sanatanbhai Ghavri.jpeg';
import RahulNanjibhaiMaruProjectImage from 'src/assets/images/projectsInstalled/RahulNanjibhaiMaruProjectImage.jpeg';
import ArunKumarJoshiProjectImage from 'src/assets/images/projectsInstalled/ArunKumarJoshiProjectImage.jpeg';
import JitendraLaxmanbhaiIndariyaProjectImage from 'src/assets/images/projectsInstalled/JitendraLaxmanbhaiIndariyaProjectImage.jpg';
import IndariyaMaheshbhaiLaxmanbhaiProjectImage from 'src/assets/images/projectsInstalled/RahulNanjibhaiMaruProjectImage1.jpeg';
import VaghelaDineshbhaiProjectImage from 'src/assets/images/projectsInstalled/Vaghela Dineshbhai.jpeg';
import ParmarHardikkumarVashrambhaiProjectImage from 'src/assets/images/projectsInstalled/ParmarHardikkumarVashrambhaiProjectImage.jpg';
import MahendraKumarYadavProjectImage from 'src/assets/images/projectsInstalled/MahendraKumarYadavProjectImage.jpeg';
import MagvaniyaSuryakantRamjibhaiProjectImage from 'src/assets/images/projectsInstalled/MagvaniyaSuryakantRamjibhaiProjectImage.jpeg';
import SameerNandkumarShahProjectImage from 'src/assets/images/projectsInstalled/SameerNandkumarShahProjectImage.jpeg';
import ZeelEquipmentPropSameerNandkumarShahProjectImage from 'src/assets/images/projectsInstalled/ZeelEquipmentPropSameerNandkumarShahProjectImage.jpeg';
import AjayKumarTripathi3KWProjectImage from 'src/assets/images/projectsInstalled/AjayKumarTripathi3KWProjectImage.jpeg';
import HarishVirvani3KWProjectImage from 'src/assets/images/projectsInstalled/HarishVirvani3KWProjectImage.jpeg';
import PriyabenAnkitkumarBhavsar3_24KWProjectImage from 'src/assets/images/projectsInstalled/PriyabenAnkitkumarBhavsar3_24KWProjectImage.jpeg';
import BhavikbhaiPareshbhaiKhokhara4_48KWProjectImage from 'src/assets/images/projectsInstalled/BhavikbhaiPareshbhaiKhokhara4_48KWProjectImage.jpeg';
import ArunKumarJoshi3KWProjectImage from 'src/assets/images/projectsInstalled/ArunKumarJoshi3KWProjectImage.jpeg';
import RahulNanjibhaiMaru3_3KWProjectImage from 'src/assets/images/projectsInstalled/RahulNanjibhaiMaru3_3KWProjectImage.jpeg';
import DeepakKumar4_86KWProjectImage from 'src/assets/images/projectsInstalled/DeepakKumar4_86KWProjectImage.jpeg';
import RamilabenSanatanbhaiGhavri3_3KWProjectImage from 'src/assets/images/projectsInstalled/RamilabenSanatanbhaiGhavri3_3KWProjectImage.jpeg';
import ManoharLal10KWProjectImage from 'src/assets/images/projectsInstalled/ManoharLal10KWProjectImage.jpeg';
import ChhinderSingh5KWProjectImage from 'src/assets/images/projectsInstalled/ChhinderSingh5KWProjectImage.jpg';
import HapaniKalpeshbhaiBhavanbhai3_3KWProjectImage from 'src/assets/images/projectsInstalled/HapaniKalpeshbhaiBhavanbhai3_3KWProjectImage.jpg';
import NarendraKrushnaroBansodkar5KWProjectImage from 'src/assets/images/projectsInstalled/NarendraKrushnaroBansodkar5KWProjectImage.jpg';
import JitendraLaxmanbhaiIndariyaLoan23_3KWProjectImage from 'src/assets/images/projectsInstalled/JitendraLaxmanbhaiIndariyaLoan23_3KWProjectImage.jpg';
import Aasha10KWProjectImage from 'src/assets/images/projectsInstalled/Aasha10KWProjectImage.jpeg';
import UmeshBharatbhaiDataniya3_3KWProjectImage from 'src/assets/images/projectsInstalled/UmeshBharatbhaiDataniya3_3KWProjectImage.jpeg';
import JagdishBairagi3_3KWProjectImage from 'src/assets/images/projectsInstalled/JagdishBairagi3_3KWProjectImage.jpeg';
import RaviSharma5KWProjectImage from 'src/assets/images/projectsInstalled/RaviSharma5KWProjectImage.jpeg';
import TejsinghAnandraoSarnaik10KWProjectImage from 'src/assets/images/projectsInstalled/TejsinghAnandraoSarnaik10KWProjectImage.jpeg';
import AkshayKishanraoKamble3KWProjectImage from 'src/assets/images/projectsInstalled/AkshayKishanraoKamble3KWProjectImage.jpeg';
import PrinjayKumar4KWProjectImage from 'src/assets/images/projectsInstalled/PrinjayKumar4KWProjectImage.jpeg';
import RajeevKumarKulshrestha4KWProjectImage from 'src/assets/images/projectsInstalled/RajeevKumarKulshrestha4KWProjectImage.jpeg';
import VikasKulshrestha4KWProjectImage from 'src/assets/images/projectsInstalled/VikasKulshrestha4KWProjectImage.jpeg';
import RajeshkumarBhikhabhaiValand4_34KWProjectImage from 'src/assets/images/projectsInstalled/RajeshkumarBhikhabhaiValand4_34KWProjectImage.jpeg';
import BrijeshKumarYadav3KWProjectImage from 'src/assets/images/projectsInstalled/BrijeshKumarYadav3KWProjectImage.jpeg';
import PremnarayanAhirwar3_3KWProjectImage from 'src/assets/images/projectsInstalled/PremnarayanAhirwar3_3KWProjectImage.jpeg';
import BhavikkumarKantilalLimbani3_48KWProjectImage from 'src/assets/images/projectsInstalled/BhavikkumarKantilalLimbani3_48KWProjectImage.jpg';
import KambleSantoshbhai3_27KWProjectImage from 'src/assets/images/projectsInstalled/KambleSantoshbhai3_27KWProjectImage.jpeg';
import RameshbhaiNanjibhaiBarvadia5_5KWProjectImage from 'src/assets/images/projectsInstalled/RameshbhaiNanjibhaiBarvadia5_5KWProjectImage.jpeg';
import UmeshMalakappaBallolli5KWProjectImage from 'src/assets/images/projectsInstalled/UmeshMalakappaBallolli5KWProjectImage.jpeg';
import BaliramVasantSurywanshi6KWProjectImage from 'src/assets/images/projectsInstalled/BaliramVasantSurywanshi6KWProjectImage.jpeg';
import VijenderPrajapat6KWProjectImage from 'src/assets/images/projectsInstalled/VijenderPrajapat6KWProjectImage.jpeg';
import AvinashAnnaraoThorat10KWProjectImage from 'src/assets/images/projectsInstalled/AvinashAnnaraoThorat10KWProjectImage.jpeg';
import ShaileshbhaiManubhaiParmar14_75KWProjectImage from 'src/assets/images/projectsInstalled/ShaileshbhaiManubhaiParmar14_75KWProjectImage.jpg';
import JitendrabhaiPatel3_3KWProjectImage from 'src/assets/images/projectsInstalled/JitendrabhaiPatel3_3KWProjectImage.jpeg';
import NikhilJaganJadhav3KWProjectImage from 'src/assets/images/projectsInstalled/NikhilJaganJadhav3KWProjectImage.jpeg';
import VishwanathShivajiGadhave5KWProjectImage from 'src/assets/images/projectsInstalled/VishwanathShivajiGadhave5KWProjectImage.jpeg';
import OmprakeshRunwal5KWProjectImage from 'src/assets/images/projectsInstalled/OmprakeshRunwal5KWProjectImage.jpeg';
import SagarSahebraoBankar3KWProjectImage from 'src/assets/images/projectsInstalled/SagarSahebraoBankar3KWProjectImage.jpeg';
import Rahul2_15KWProjectImage from 'src/assets/images/projectsInstalled/Rahul2_15KWProjectImage.jpeg';
import Bihari3_2KWProjectImage from 'src/assets/images/projectsInstalled/Bihari3_2KWProjectImage.jpeg';
import AshishPremprakashSharma3_5KWProjectImage from 'src/assets/images/projectsInstalled/AshishPremprakashSharma3_5KWProjectImage.jpeg';
import JigneshShambhubhaiDesai5KWProjectImage from 'src/assets/images/projectsInstalled/JigneshShambhubhaiDesai5KWProjectImage.jpeg';
import JagdishPrasadVijayraniya3KWProjectImage from 'src/assets/images/projectsInstalled/JagdishPrasadVijayraniya3KWProjectImage.jpeg';
import GokulChandrakantMhaske3KWProjectImage from 'src/assets/images/projectsInstalled/GokulChandrakantMhaske3KWProjectImage.jpg';
import ShravanGautam5KWProjectImage from 'src/assets/images/projectsInstalled/ShravanGautam5KWProjectImage.jpeg';
import ShankarLalGadri3_7KWProjectImage from 'src/assets/images/projectsInstalled/ShankarLalGadri3_7KWProjectImage.jpeg';
import SwapnilSambhajiPhadake4_5KWProjectImage from 'src/assets/images/projectsInstalled/SwapnilSambhajiPhadake4_5KWProjectImage.png';
import BalasahebParasaramSale10KWProjectImage from 'src/assets/images/projectsInstalled/BalasahebParasaramSale10KWProjectImage.png';
import PrakashJaiswal3_06KWProjectImage from 'src/assets/images/projectsInstalled/PrakashJaiswal3_06KWProjectImage.png';
import GirishkumarMalivad3_27KWProjectImage from 'src/assets/images/projectsInstalled/GirishkumarMalivad3_27KWProjectImage.png';
import Siddharth3KWProjectImage from 'src/assets/images/projectsInstalled/Siddharth3KWProjectImage.png';
import JitendraChaurasiya3_6KWProjectImage from 'src/assets/images/projectsInstalled/JitendraChaurasiya3_6KWProjectImage.png';
import VenugopalCharyAnnoju3_5KWProjectImage from 'src/assets/images/projectsInstalled/VenugopalCharyAnnoju3_5KWProjectImage.png';
import SunilBaburaoLadvanjari3_5KWProjectImage from 'src/assets/images/projectsInstalled/SunilBaburaoLadvanjari3_5KWProjectImage.png';
import AwadhNaresh3_7KWProjectImage from 'src/assets/images/projectsInstalled/AwadhNaresh3_7KWProjectImage.png';
import NavinjiThakor2_24KWProjectImage from 'src/assets/images/projectsInstalled/NavinjiThakor2_24KWProjectImage.jpg';
import SidhaniSreenivasulu3KWProjectImage from 'src/assets/images/projectsInstalled/SidhaniSreenivasulu3KWProjectImage.jpeg';
import PoonamSanjayKothavale3_18KWProjectImage from 'src/assets/images/projectsInstalled/PoonamSanjayKothavale3_18KWProjectImage.jpeg';
import ArvindbhaiKarshanbhaiRathod5_5KWProjectImage from 'src/assets/images/projectsInstalled/ArvindbhaiKarshanbhaiRathod5_5KWProjectImage.jpeg';
import KarreVeerabhadram3KWProjectImage from 'src/assets/images/projectsInstalled/KarreVeerabhadram3KWProjectImage.jpeg';
import DipakkumarNatavarlalRaval3_27KWProjectImage from 'src/assets/images/projectsInstalled/DipakkumarNatavarlalRaval3_27KWProjectImage.jpeg';
import Sukhadev3_3KWProjectImage from 'src/assets/images/projectsInstalled/Sukhadev3_3KWProjectImage.jpeg';
import RajnikantVaghela4_6KWProjectImage from 'src/assets/images/projectsInstalled/RajnikantVaghela4_6KWProjectImage.jpg';
import SantoshRanganathChavan10KWProjectImage from 'src/assets/images/projectsInstalled/SantoshRanganathChavan10KWProjectImage.png';
import GirishPandharinathSiddhapure3KWProjectImage from 'src/assets/images/projectsInstalled/GirishPandharinathSiddhapure3KWProjectImage.png';
import AlokKumarRai4KWProjectImage from 'src/assets/images/projectsInstalled/AlokKumarRai4KWProjectImage.png';
import SirajRaj3_48KWProjectImage from 'src/assets/images/projectsInstalled/SirajRaj3_48KWProjectImage.jpg';
import SanjayRana5_8KWProjectImage from 'src/assets/images/projectsInstalled/SanjayRana5_8KWProjectImage.png';
import VandanaYadav3_48KWProjectImage from 'src/assets/images/projectsInstalled/VandanaYadav3_48KWProjectImage.jpeg';
import SunilBabanGirame3_3KWProjectImage from 'src/assets/images/projectsInstalled/SunilBabanGirame3_3KWProjectImage.png';
import SahilKumar3_1KWProjectImage from 'src/assets/images/projectsInstalled/SahilKumar3_1KWProjectImage.jpeg';
import NoratanMal10KWProjectImage from 'src/assets/images/projectsInstalled/NoratanMal10KWProjectImage.jpeg';
import MayankManiTripathi5KWProjectImage from 'src/assets/images/projectsInstalled/MayankManiTripathi5KWProjectImage.png';
import HiralAnilbhaiKoshti4_4KWProjectImage from 'src/assets/images/projectsInstalled/HiralAnilbhaiKoshti4_4KWProjectImage.jpeg';
import AshishkumarNaranbhaiParmar3_6KWProjectImage from 'src/assets/images/projectsInstalled/AshishkumarNaranbhaiParmar3_6KWProjectImage.jpeg';
export const socialLinks = {
  linkedin: 'https://in.linkedin.com/company/solfin-sustainable-financing',
  twitter: 'https://twitter.com/solfin_india',
  facebook:
    'https://www.facebook.com/people/Solfin-Sustainable-Finance/61579627534064'
};

export const epcRegistrationTypes = [
  { id: 1, name: 'Sole Prop', label: 'Sole Prop' },
  { id: 2, name: 'Other', label: 'Other' }
];

export const documentsCategory = {
  COMPANY_DOCUMENT: 'Company Document',
  SIGNATORY_DOCUMENT: 'Signatory Document',
  FETCH_PENDING_DOCUMENT: 'Documents Pending'
};

export const distributorTabs = [
  { id: 1, label: 'New Tasks' },
  { id: 2, label: 'In Progress Tasks' }
];

export const epcReferredLeadsTabs = [
  { id: 1, label: 'Normal Leads' },
  { id: 2, label: 'Excel Leads' }
];

export const ourProjectList = [
  {
    id: 107,
    location: 'Panchmahals, Gujarat',
    units: '3.6 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [AshishkumarNaranbhaiParmar3_6KWProjectImage]
  },
  {
    id: 106,
    location: 'Ahmedabad, Gujarat',
    units: '4.4 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [HiralAnilbhaiKoshti4_4KWProjectImage]
  },
  {
    id: 105,
    location: 'Gorakhpur, Uttar Pradesh',
    units: '5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [MayankManiTripathi5KWProjectImage]
  },
  {
    id: 104,
    location: 'Nagnaur, Rajasthan',
    units: '10 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [NoratanMal10KWProjectImage]
  },
  {
    id: 103,
    location: 'Ganganagar, Rajasthan',
    units: '3.1 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [SahilKumar3_1KWProjectImage]
  },
  {
    id: 102,
    location: 'Pune, Maharashtra',
    units: '3.3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [SunilBabanGirame3_3KWProjectImage]
  },
  {
    id: 101,
    location: 'Lucknow, Uttar Pradesh',
    units: '3.48 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [VandanaYadav3_48KWProjectImage]
  },
  {
    id: 100,
    location: 'Palwal, Haryana',
    units: '5.8 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [SanjayRana5_8KWProjectImage]
  },
  {
    id: 99,
    location: 'Bharuch, Gujarat',
    units: '3.48 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [SirajRaj3_48KWProjectImage]
  },
  {
    id: 98,
    location: 'Gorakhpur, Uttar Pradesh',
    units: '4 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [AlokKumarRai4KWProjectImage]
  },
  {
    id: 97,
    location: 'Jalgaon, Maharashtra',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [GirishPandharinathSiddhapure3KWProjectImage]
  },
  {
    id: 96,
    location: 'Aurangabad, Maharashtra',
    units: '10 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [SantoshRanganathChavan10KWProjectImage]
  },
  {
    id: 95,
    location: 'Surat, Gujarat',
    units: '4.6 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [RajnikantVaghela4_6KWProjectImage]
  },
  {
    id: 94,
    location: 'Hanumangarh, Rajasthan',
    units: '3.3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [Sukhadev3_3KWProjectImage]
  },
  {
    id: 93,
    location: 'Mehsana, Gujarat',
    units: '3.27 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [DipakkumarNatavarlalRaval3_27KWProjectImage]
  },
  {
    id: 92,
    location: 'K.V. Rangareddy, Telangana',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [KarreVeerabhadram3KWProjectImage]
  },
  {
    id: 91,
    location: 'Bhavnagar, Gujarat',
    units: '5.5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ArvindbhaiKarshanbhaiRathod5_5KWProjectImage]
  },
  {
    id: 90,
    location: 'Kolhapur, Maharashtra',
    units: '3.18 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [PoonamSanjayKothavale3_18KWProjectImage]
  },
  {
    id: 89,
    location: 'Chittoor, Andhra Pradesh',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [SidhaniSreenivasulu3KWProjectImage]
  },
  {
    id: 88,
    location: 'Gandhinagar, Gujarat',
    units: '2.24 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [NavinjiThakor2_24KWProjectImage]
  },
  {
    id: 87,
    location: 'Rajpura, Rajasthan',
    units: '3.7 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ShankarLalGadri3_7KWProjectImage]
  },
  {
    id: 86,
    location: 'Kanpur, Uttar Pradesh',
    units: '3.7 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [AwadhNaresh3_7KWProjectImage]
  },
  {
    id: 85,
    location: 'Jabalpur, Madhya Pradesh',
    units: '5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ShravanGautam5KWProjectImage]
  },
  {
    id: 84,
    location: 'Pune, Maharashtra',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [GokulChandrakantMhaske3KWProjectImage]
  },
  {
    id: 83,
    location: 'Reengus, Rajasthan',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [JagdishPrasadVijayraniya3KWProjectImage]
  },
  {
    id: 82,
    location: 'Ahmedabad, Gujarat',
    units: '5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [JigneshShambhubhaiDesai5KWProjectImage]
  },
  {
    id: 81,
    location: 'Jalgaon, Maharashtra',
    units: '3.5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [SunilBaburaoLadvanjari3_5KWProjectImage]
  },
  {
    id: 80,
    location: 'Jalgaon, Maharashtra',
    units: '3.5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [AshishPremprakashSharma3_5KWProjectImage]
  },
  {
    id: 79,
    location: 'Gorakhpur, Uttar Pradesh',
    units: '3.2 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [Bihari3_2KWProjectImage]
  },
  {
    id: 78,
    location: 'Mirjapur, Uttar Pradesh',
    units: '2.15 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [Rahul2_15KWProjectImage]
  },
  {
    id: 77,
    location: 'Pune, Maharashtra',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [SagarSahebraoBankar3KWProjectImage]
  },
  {
    id: 76,
    location: 'Malkajgiri, Telangana',
    units: '3.5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [VenugopalCharyAnnoju3_5KWProjectImage]
  },
  {
    id: 75,
    location: 'Chittorgarh, Rajasthan',
    units: '5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [OmprakeshRunwal5KWProjectImage]
  },
  {
    id: 74,
    location: 'Prayagraj, Uttar Pradesh',
    units: '3.6 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [JitendraChaurasiya3_6KWProjectImage]
  },
  {
    id: 73,
    location: 'Pune, Maharashtra',
    units: '5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [VishwanathShivajiGadhave5KWProjectImage]
  },
  {
    id: 72,
    location: 'Jalgaon, Maharashtra',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [NikhilJaganJadhav3KWProjectImage]
  },
  {
    id: 71,
    location: 'Saharanpur, Uttar Pradesh',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [Siddharth3KWProjectImage]
  },
  {
    id: 70,
    location: 'Gandhinagar, Gujarat',
    units: '3.30 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [JitendrabhaiPatel3_3KWProjectImage]
  },
  {
    id: 69,
    location: 'Anand, Gujarat',
    units: '14.75 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ShaileshbhaiManubhaiParmar14_75KWProjectImage]
  },
  {
    id: 68,
    location: 'Mahisagar, Gujarat',
    units: '3.27 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [GirishkumarMalivad3_27KWProjectImage]
  },
  {
    id: 67,
    location: 'Latur, Maharashtra',
    units: '10 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [AvinashAnnaraoThorat10KWProjectImage]
  },
  {
    id: 66,
    location: 'Alwar, Rajasthan',
    units: '6 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [VijenderPrajapat6KWProjectImage]
  },
  {
    id: 65,
    location: 'Latur, Maharashtra',
    units: '6 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [BaliramVasantSurywanshi6KWProjectImage]
  },
  {
    id: 64,
    location: 'Varanasi, Uttar Pradesh',
    units: '3.06 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [PrakashJaiswal3_06KWProjectImage]
  },
  {
    id: 63,
    location: 'Solapur, Maharashtra',
    units: '5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [UmeshMalakappaBallolli5KWProjectImage]
  },
  {
    id: 62,
    location: 'Junagadh, Gujarat',
    units: '5.5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [RameshbhaiNanjibhaiBarvadia5_5KWProjectImage]
  },
  {
    id: 61,
    location: 'Surat, Gujarat',
    units: '3.27 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [KambleSantoshbhai3_27KWProjectImage]
  },
  {
    id: 60,
    location: 'Kachchh, Gujarat',
    units: '3.48 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [BhavikkumarKantilalLimbani3_48KWProjectImage]
  },
  {
    id: 59,
    location: 'Vishisha, Madhya Pradesh',
    units: '3.30 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [PremnarayanAhirwar3_3KWProjectImage]
  },
  {
    id: 58,
    location: 'Nashik, Maharashtra',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [BrijeshKumarYadav3KWProjectImage]
  },
  {
    id: 57,
    location: 'Panchmahals, Gujarat',
    units: '4.34 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [RajeshkumarBhikhabhaiValand4_34KWProjectImage]
  },
  {
    id: 56,
    location: 'Samai Pur, Delhi',
    units: '4 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [VikasKulshrestha4KWProjectImage]
  },
  {
    id: 55,
    location: 'Libas Pur, Delhi',
    units: '4 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [RajeevKumarKulshrestha4KWProjectImage]
  },
  {
    id: 54,
    location: 'Libas Pur, Delhi',
    units: '4 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [PrinjayKumar4KWProjectImage]
  },
  {
    id: 53,
    location: 'Nanded, Maharashtra',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [AkshayKishanraoKamble3KWProjectImage]
  },
  {
    id: 52,
    location: 'Aurangabad, Maharashtra',
    units: '10 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [BalasahebParasaramSale10KWProjectImage]
  },
  {
    id: 51,
    location: 'Chikurde, Maharashtra',
    units: '10 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [TejsinghAnandraoSarnaik10KWProjectImage]
  },
  {
    id: 50,
    location: 'Deoli, Rajasthan',
    units: '5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [RaviSharma5KWProjectImage]
  },
  {
    id: 49,
    location: 'Jaipur, Rajasthan',
    units: '3.3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [JagdishBairagi3_3KWProjectImage]
  },
  {
    id: 48,
    location: 'Pune, Maharashtra',
    units: '4.5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [SwapnilSambhajiPhadake4_5KWProjectImage]
  },
  {
    id: 47,
    location: 'Ahmedabad, Gujarat',
    units: '3.3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [UmeshBharatbhaiDataniya3_3KWProjectImage]
  },
  {
    id: 46,
    location: 'Alwar, Rajasthan',
    units: '10 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [Aasha10KWProjectImage]
  },
  {
    id: 45,
    location: 'Ganganagar, Rajasthan',
    units: '5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ChhinderSingh5KWProjectImage]
  },
  {
    id: 44,
    location: 'Churu, Rajasthan',
    units: '10 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ManoharLal10KWProjectImage]
  },
  {
    id: 43,
    location: 'Rajkot, Gujarat',
    units: '3.3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [RamilabenSanatanbhaiGhavri3_3KWProjectImage]
  },
  {
    id: 42,
    location: 'Hudkeshwar, Maharashtra',
    units: '5 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [NarendraKrushnaroBansodkar5KWProjectImage]
  },
  {
    id: 41,
    location: 'Balotra, Rajasthan',
    units: '4.86 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [DeepakKumar4_86KWProjectImage]
  },
  {
    id: 40,
    location: 'Khokhdadad, Gujarat',
    units: '3.3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [RahulNanjibhaiMaru3_3KWProjectImage]
  },
  {
    id: 39,
    location: 'Rajkot, Gujarat',
    units: '3.3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [HapaniKalpeshbhaiBhavanbhai3_3KWProjectImage]
  },
  {
    id: 38,
    location: 'Jhunjhunu, Rajasthan',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ArunKumarJoshi3KWProjectImage]
  },
  {
    id: 37,
    location: 'Surendranagar, Gujarat',
    units: '4.48 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [BhavikbhaiPareshbhaiKhokhara4_48KWProjectImage]
  },
  {
    id: 36,
    location: 'Rajkot, Gujarat',
    units: '3.30 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [JitendraLaxmanbhaiIndariyaLoan23_3KWProjectImage]
  },
  {
    id: 35,
    location: 'Rajkot, Gujarat',
    units: '3.30 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [JitendraLaxmanbhaiIndariyaProjectImage]
  },
  {
    id: 34,
    location: 'Prantij, Gujarat',
    units: '3.24 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [PriyabenAnkitkumarBhavsar3_24KWProjectImage]
  },
  {
    id: 33,
    location: 'Agra, Uttar Pradesh',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [HarishVirvani3KWProjectImage]
  },
  {
    id: 32,
    location: 'Mahokhar, Uttar Pradesh',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [AjayKumarTripathi3KWProjectImage]
  },
  {
    id: 31,
    location: 'Ahmedabad, Gujarat',
    units: '20.3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ZeelEquipmentPropSameerNandkumarShahProjectImage]
  },
  {
    id: 30,
    location: 'Ahmedabad, Gujarat',
    units: '9.8 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [SameerNandkumarShahProjectImage]
  },
  {
    id: 29,
    location: 'Rajkot, Gujarat',
    units: '4.52 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [MagvaniyaSuryakantRamjibhaiProjectImage]
  },
  {
    id: 28,
    location: 'Prayagraj Uttar Pradesh',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [MahendraKumarYadavProjectImage]
  },
  {
    id: 27,
    location: 'Rajkot, Gujarat',
    units: '3.27 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ParmarHardikkumarVashrambhaiProjectImage]
  },
  {
    id: 26,
    location: 'Ahmedabad, Gujarat',
    units: '4.32 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [VaghelaDineshbhaiProjectImage]
  },
  {
    id: 25,
    location: 'Indariya Maheshbhai Laxmanbhai',
    units: '3.3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [IndariyaMaheshbhaiLaxmanbhaiProjectImage]
  },
  {
    id: 24,
    location: 'Rajkot, Gujarat',
    units: '3.3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [JitendraLaxmanbhaiIndariyaProjectImage]
  },
  {
    id: 23,
    location: 'Jhunjhunu, Rajasthan',
    units: '3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ArunKumarJoshiProjectImage]
  },
  {
    id: 22,
    location: 'Rajkot, Gujarat',
    units: '3.3 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [RahulNanjibhaiMaruProjectImage]
  },
  {
    id: 21,
    location: 'Rajkot, Gujarat',
    units: '3.48 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [RamilabenKantilalPatelProjectImage]
  },
  {
    id: 20,
    location: 'Chhapra, Bihar',
    units: '15 Solar Lights',
    typeOfProject: 'Pole Solar Lights',
    projectImageUrl: [
      Patanjali_BiharProjectImage1,
      Patanjali_BiharProjectImage2,
      Patanjali_BiharProjectImage3,
      Patanjali_BiharProjectImage4,
      Patanjali_BiharProjectImage5
    ]
  },
  {
    id: 19,
    location: 'Jaipur, Rajasthan',
    units: '3.3KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [Laxmi_Rajasthan5KWProjectImage]
  },
  {
    id: 18,
    location: 'Bhandara,Maharashtra',
    units: '3.3KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ChandrajitBhagwatZingare3_3KWProjectImage]
  },
  {
    id: 17,
    location: 'Rajkot, Gujarat',
    units: '3.39KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [RojasaraPrakashGopalbhai3_39KWProjectImage]
  },
  {
    id: 16,
    location: 'Rajkot, Gujarat',
    units: '3.85KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [RamaniBhavinbhaiDevraj3_85KWProjectImage]
  },
  {
    id: 15,
    location: 'Tadekeshwar, Gujarat',
    units: '4.56KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [AbdulsamadYakub4_5KWProjectImage]
  },
  {
    id: 14,
    location: 'Ahmedabad, Gujarat',
    units: '9.6KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [JiteshOde9_6KWProjectImage]
  },
  {
    id: 13,
    location: 'Jahangirpuri, Delhi',
    units: '61KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [JindalPolychem61KWProjectImage]
  },
  {
    id: 12,
    location: 'Jaipur, Rajasthan',
    units: '400KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [VedamGranites400KWJaipurProjectImage]
  },
  {
    id: 11,
    location: 'Keshod, Gujarat',
    units: '3.24KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [Keshod_Gujarat3_24KWPlantImage]
  },
  {
    id: 10,
    location: 'Gundasara, Gujarat',
    units: '3.27KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [Gundasara_Gujarat3_27KWPlantImage]
  },
  {
    id: 9,
    location: 'Vellore, Tamil Nadu',
    units: '3KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [SatyachandranVekatraman3KWPojectImage]
  },
  {
    id: 8,
    location: 'Ahmedabad, Gujarat',
    units: '4.6KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [GuptaVishnukumar4_6KWProjectImage]
  },
  {
    id: 7,
    location: 'Panchmahal, Gujarat',
    units: '3.3KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ParekhSangitaben3_3KWProjectImage]
  },
  {
    id: 6,
    location: 'Ahmedabad, Gujarat',
    units: '4.6KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [prajapatiPradip4_6KWProjectImage]
  },
  {
    id: 5,
    location: 'Thane, Maharashtra',
    units: '10 KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [satyamOLeander10KWProjectImage]
  },
  {
    id: 4,
    location: 'Jamnagar, Gujarat',
    units: '4.36KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [bhutDilip4_36KWJamnagarImage]
  },
  {
    id: 3,
    location: 'Pune, Maharashtra',
    units: '70KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [ceratecAntara70KWPlantImage]
  },
  {
    id: 2,
    location: 'kushinagar, Uttar Pradesh',
    units: '17KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [kushinagar17KWPlantImage]
  },
  {
    id: 1,
    location: 'Gonda, Uttar Pradesh',
    units: '10KW',
    typeOfProject: 'On-Grid Roof Top Solar',
    projectImageUrl: [gonda10KWPlantImage]
  }
];

export const howWeWorkSteps = [
  {
    title: 'System Design',
    text: 'EPC would conduct a site visit and design a system',
    icon: '/images/solar-panel.svg',
    alt: 'System Design'
  },
  {
    title: 'Consultation',
    text: 'Discuss with EPC, the project in detail on Kwh requirement, Net Metering, Storage etc.',
    icon: '/images/consultation.svg',
    alt: 'Consultation'
  },
  {
    title: 'Flexible Financing',
    text: 'Choose best finance options basis interest rate, tenure, via state of art Digital loan processing system',
    icon: '/images/payment-plan.svg',
    alt: 'Payment Plan'
  },
  {
    title: 'Installation',
    text: 'Customer can get the project installed after closure of EPC and Financing contracts.',
    icon: '/images/installation.svg',
    alt: 'Installation'
  },
  {
    title: 'Monitoring & Maintenance',
    text: 'Low cost maintenance through EPC and special maintenance partners',
    icon: '/images/monitoring-maintance.svg',
    alt: 'Monitoring & Maintenance'
  },
  {
    title: 'Plant Optimization & Expansion',
    text: 'Storage Options and utilization options',
    icon: '/images/battery-optimization.svg',
    alt: 'Battery Optimization'
  }
];

export const loanFinancingType = {
  RESIDENTIAL: 'Residential Lead',
  COMMERCIAL_AND_INDUSTRIAL: 'C & I Lead',
  PLL: 'Performance Linked Loan',
  OTHER: 'Housing Societies / Other'
};

export const internalPOCsTypeEnums = {
  SALES: 'SALES_POC',
  CREDIT: 'CREDIT_POC',
  OPS: 'OPS_POC',
  MARKETING: 'MARKETING_POC'
};

export const masterLeadType = [
  {
    leadTypeEnum: 'RESIDENTIAL',
    leadTypeName: 'Residential Lead',
    locationTypeCode: 'RSD'
  },
  {
    leadTypeEnum: 'COMMERCIAL_AND_INDUSTRIAL',
    leadTypeName: 'C & I Lead',
    locationTypeCode: 'CMR'
  },
  {
    leadTypeEnum: 'PLL',
    leadTypeName: 'Performance Linked Loan',
    locationTypeCode: 'PLL'
  },
  {
    leadTypeEnum: 'OTHER',
    leadTypeName: 'Housing Societies / Other',
    locationTypeCode: 'HS'
  }
];

export const leadSources = [
  { sourceName: 'Customer Registration', sourceEnum: 'CUSTOMER_REGISTRATION' },
  { sourceName: 'Solar Calculator', sourceEnum: 'SOLAR_CALCULATOR' },
  { sourceName: 'Contact', sourceEnum: 'CONTACT' },
  { sourceName: 'Other', sourceEnum: 'OTHER' },
  { sourceName: 'Sales', sourceEnum: 'SALES' },
  { sourceName: 'EPC', sourceEnum: 'EPC' },
  { sourceName: 'WAAREE-PRIME', sourceEnum: 'WAAREE_PRIME' }
];

export const epcLeadSources = [
  { sourceName: 'WCS', sourceEnum: 'WCS' },
  { sourceName: 'Organic', sourceEnum: 'ORGANIC' },
  { sourceName: 'Email Campaign', sourceEnum: 'EMAIL_CAMPAIGN' },
  { sourceName: 'WAAREE Prime', sourceEnum: 'WAAREE_PRIME' },
  { sourceName: 'Offline Campaign', sourceEnum: 'OFF_LINE_CAMPAIGN' },
  { sourceName: 'WhatsApp Campaign', sourceEnum: 'WHATSAPP_CAMPAIGN' },
  { sourceName: 'Bulk Upload', sourceEnum: 'BULK_UPLOAD' },
  { sourceName: 'IVR', sourceEnum: 'IVR' },
  { sourceName: 'RCS', sourceEnum: 'RCS' },
  { sourceName: 'EPC Dashboard', sourceEnum: 'EPC_DASHBOARD' }
];

export const loanFinancingCategories = [
  {
    id: 'RESIDENTIAL',
    imageUrl:
      'https://png.pngtree.com/background/20231030/original/pngtree-contract-form-and-approved-home-loan-stunning-3d-illustration-picture-image_5808578.jpg',
    imageTitle: 'Residential Lead',
    isActive: true,
    title: 'Residential Lead'
  },
  {
    id: 'COMMERCIAL_AND_INDUSTRIAL',
    imageUrl:
      'https://img.freepik.com/premium-photo/3d-flat-icon-business-financial-concept-bankers-discussing-finance-services-loan-option_980716-68802.jpg',
    imageTitle: 'C & I',
    isActive: true,
    title: 'C & I'
  },
  {
    id: 'PLL',
    imageUrl:
      'https://png.pngtree.com/background/20231030/original/pngtree-contract-form-and-approved-home-loan-stunning-3d-illustration-picture-image_5808578.jpg',
    imageTitle: 'Performance Linked Loan',
    isActive: false,
    title: 'Performance Linked Loan'
  }
  // {
  //   id: 'OTHER',
  //   imageUrl:
  //     'https://static.vecteezy.com/system/resources/previews/021/596/685/non_2x/3d-illustration-loan-in-credit-and-loan-set-free-png.png',
  //   imageTitle: 'Other',
  //   isActive: true,
  //   title: 'Housing Societies / Other'
  // }
];

export const solfinWhatsSupportNumber = '+919599446877';
export const groupLink = 'https://chat.whatsapp.com/IYfGlyGK3qg4o3cATEUjCT';

export const whatsappSupportDefaultMessage =
  'Hello, \nI need your assistance regarding the EPC.';
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_NUMBER = 0;

export const masterPermissionsSet = [
  'LEADS_UPDATE',
  'LEADS_CREATE',
  'LEADS_VIEW',
  'LEADS_DELETE',
  'APPLICATION_UPDATE',
  'APPLICATION_DELETE',
  'APPLICATION_VIEW',
  'CUSTOMERS_VIEW',
  'CUSTOMERS_DELETE',
  'CUSTOMERS_UPDATE',
  'CUSTOMERS_CREATE',
  'EPC_VIEW',
  'EPC_UPDATE',
  'EPC_CREATE',
  'EPC_DELETE',
  'DISTRIBUTOR_VIEW',
  'DISTRIBUTOR_CREATE',
  'DISTRIBUTOR_DELETE',
  'DISTRIBUTOR_UPDATE',
  'INVOICES_VIEW',
  'INVOICES_CREATE',
  'INVOICES_DELETE',
  'INVOICES_UPDATE',
  'DSA_VIEW',
  'DSA_CREATE',
  'DSA_DELETE',
  'DSA_UPDATE',
  'PROJECTS_VIEW',
  'PROJECTS_DELETE',
  'PROJECTS_CREATE',
  'PROJECTS_UPDATE',
  'UPDATE_KYC',
  'LOAN_VIEW',
  'LOAN_CREATE',
  'LOAN_DELETE',
  'LOAN_UPDATE'
];

export const adminPermissions = {
  LEADS_UPDATE: true,
  LEADS_CREATE: true,
  APPLICATION_VIEW: true,
  CUSTOMERS_UPDATE: true,
  PROJECTS_CREATE: true,
  INVOICES_VIEW: true,
  EPC_VIEW: true,
  DSA_CREATE: true,
  UPDATE_KYC: true,
  APPLICATION_UPDATE: true
};

export const INITIAL_PAGE_NUMBER = 0;
export const INITIAL_PAGE_SIZE = 10;

export const indianStateColors = {
  AndhraPradesh: 'linear-gradient(120deg, #FF7E5F, #FEB47B)',
  ArunachalPradesh: 'linear-gradient(120deg, #4CA1AF, #C4E0E5)',
  Assam: 'linear-gradient(120deg, #FF9966, #FF5E62)',
  Bihar: 'linear-gradient(120deg, #56CCF2, #2F80ED)',
  Chhattisgarh: 'linear-gradient(120deg, #FF9A8B, #FF6A88)',
  Goa: 'linear-gradient(120deg, #36D1DC, #5B86E5)',
  Gujarat: 'linear-gradient(120deg, #8E2DE2, #4A00E0)',
  Haryana: 'linear-gradient(120deg, #43CEA2, #185A9D)',
  HimachalPradesh: 'linear-gradient(120deg, #FFB75E, #ED8F03)',
  Jharkhand: 'linear-gradient(120deg, #00C6FF, #0072FF)',
  Karnataka: 'linear-gradient(120deg, #DCE35B, #45B649)',
  Kerala: 'linear-gradient(120deg, #FF5F6D, #FFC371)',
  MadhyaPradesh: 'linear-gradient(120deg, #12C2E9, #C471ED, #F64F59)',
  Maharashtra: 'linear-gradient(120deg, #FF416C, #FF4B2B)',
  Manipur: 'linear-gradient(120deg, #1FA2FF, #12D8FA, #A6FFCB)',
  Meghalaya: 'linear-gradient(120deg, #00B4DB, #0083B0)',
  Mizoram: 'linear-gradient(120deg, #43C6AC, #191654)',
  Nagaland: 'linear-gradient(120deg, #7F00FF, #E100FF)',
  Odisha: 'linear-gradient(120deg, #D9A7C7, #FFFCDC)',
  Punjab: 'linear-gradient(120deg, #F7971E, #FFD200)',
  Rajasthan: 'linear-gradient(120deg, #FDFC47, #24FE41)',
  Sikkim: 'linear-gradient(120deg, #F4D03F, #16A085)',
  TamilNadu: 'linear-gradient(120deg, #1D976C, #93F9B9)',
  Telangana: 'linear-gradient(120deg, #FF512F, #DD2476)',
  Tripura: 'linear-gradient(120deg, #FF758C, #FF7EB3)',
  UttarPradesh: 'linear-gradient(120deg, #F3E7E9, #E3EEFF)',
  Uttarakhand: 'linear-gradient(120deg, #52ACFF, #FFE32C)',
  WestBengal: 'linear-gradient(120deg, #FF9A8B, #FF6A88, #FF99AC)',

  // Union Territories
  AndamanAndNicobarIslands: 'linear-gradient(120deg, #FBAB7E, #F7CE68)',
  Chandigarh: 'linear-gradient(120deg, #4AC29A, #BDFFF3)',
  DadraAndNagarHaveliAndDamanAndDiu:
    'linear-gradient(120deg, #FA709A, #FEE140)',
  Delhi: 'linear-gradient(120deg, #30E8BF, #FF8235)',
  JammuAndKashmir: 'linear-gradient(120deg, #74EBD5, #9FACE6)',
  Ladakh: 'linear-gradient(120deg, #FFDEE9, #B5FFFC)',
  Lakshadweep: 'linear-gradient(120deg, #43E97B, #38F9D7)',
  Puducherry: 'linear-gradient(120deg, #36D1DC, #5B86E5)'
};

export const paymentStatusOptions = [
  {
    enumName: 'ON_TIME',
    status: 'On time'
  },
  {
    enumName: 'NPA',
    status: 'Delayed'
  },
  {
    enumName: 'OVER_DUE',
    status: 'Over due'
  }
];

export const LOAN_DOCUMENT_TYPES = {
  WELCOME_LETTER: {
    key: 'WELCOME_LETTER',
    label: 'Welcome Letter',
    isMonthly: false,
    required: true
  },
  SANCTION_LETTER_SIGNED: {
    key: 'SANCTION_LETTER_SIGNED',
    label: 'Sanction Letter (Signed)',
    isMonthly: false,
    required: true
  },
  LOAN_AGREEMENT_SIGNED: {
    key: 'LOAN_AGREEMENT_SIGNED',
    label: 'Loan Agreement (Signed)',
    isMonthly: false,
    required: true
  },
  LOAN_NOC: {
    key: 'LOAN_NOC',
    label: 'Loan NOC',
    isMonthly: false,
    required: false
  },
  MONTHLY_STATEMENT: {
    key: 'MONTHLY_STATEMENT',
    label: 'Monthly Statement',
    isMonthly: true,
    required: false
  }
};

export const APPLICATION_UPLOADED_DOCUMENTS = {
  ELECTRICITY_BILL: {
    key: 'ELECTRICITY_BILL',
    label: 'Electricity Bill',
    isMonthly: false,
    required: false
  },
  GST_RETURN: {
    key: 'GST_RETURN',
    label: 'GST Return',
    isMonthly: false,
    required: false
  },
  GST_CERTIFICATE: {
    key: 'GST_CERTIFICATE',
    label: 'GST Certificate',
    isMonthly: false,
    required: false
  },
  INVOICE: {
    key: 'INVOICE',
    label: 'Invoice',
    isMonthly: false,
    required: false
  }
};

export const DETAILED_FIELD_CONFIG = {
  // Section A: Borrower Information
  sectionA: {
    title: 'Applicant Details',
    details:
      'Please provide details of the borrower, including business and registration information.',
    fields: {
      borrowerName: {
        label: 'Name of Borrower',
        type: 'text',
        validation: { required: true }
      },
      borrowerType: {
        label: 'Constitution of Borrower',
        type: 'select',
        options: ['Individual', 'Partnership', 'Company', 'Society'],
        validation: { required: true }
      },
      businessType: {
        label: 'Nature of Business',
        type: 'text',
        validation: { required: true }
      },
      officeAddress: {
        label: 'Registered Office Address',
        type: 'textarea',
        validation: { required: true }
      },
      dateOfIncorporation: {
        label: 'Date of Incorporation',
        type: 'date',
        validation: { required: true }
      },
      cin: {
        label: 'CIN/Registration Certificate',
        type: 'text'
      },
      pan: {
        label: 'PAN',
        type: 'text',
        validation: { required: true }
      },
      gst: {
        label: 'GST ',
        type: 'text'
      },
      aadhaar: {
        label: 'Aadhaar',
        type: 'text'
      },
      udyam: {
        label: 'Udyam Card (In case of bussiness)',
        type: 'text'
      },
      email: {
        label: 'Email',
        type: 'text',
        validation: { email: true, required: true }
      },
      phone: {
        label: 'Phone',
        type: 'text',
        validation: { phone: true, required: true }
      },
      voterId: {
        label: 'Voter ID ',
        type: 'text'
      },
      passportNo: {
        label: 'Passport Number ',
        type: 'text'
      }
    }
  },
  signatoryDetails: {
    title: 'Signatory',
    details:
      'Provide details of the authorized signatories, including contact and identification information.',
    canAddedMode: true,
    maxCount: 2,
    fields: {
      signatoryName: {
        label: 'Name of Authorized Signatory',
        type: 'text',
        validation: { required: true }
      },
      signatoryPan: {
        label: 'PAN of Authorized Signatory',
        validation: { required: true },
        type: 'text'
      },
      // signatoryAadhaar: {
      //   label: 'Aadhaar of Authorized Signatory',
      //   validation: { required: false },
      //   type: 'number'
      // },
      signatoryAddress: {
        label: 'Address of Authorized Signatory',
        validation: { required: true },
        type: 'textarea'
      },
      signatoryEmail: {
        label: 'Email of Authorized Signatory',
        type: 'text',
        validation: { email: true, required: true }
      },
      signatoryPhone: {
        label: 'Phone No of Authorized Signatory',
        type: 'text',
        validation: { phone: true, required: true }
      },
      signatoryImage: {
        label: 'Upload Photo',
        type: 'file',
        validation: {
          maxSize: 5,
          required: true,
          allowedTypes: ['image/jpeg', 'image/png']
        }
      }
    }
  },
  coApplicantDetails: {
    title: 'Co-Applicant',
    details: 'Provide details of the co-applicant.',
    fields: {
      name: {
        label: 'Name of Co-Applicant',
        type: 'text',
        validation: { required: true }
      },
      pan: {
        label: 'PAN of Co-Applicant',
        type: 'text',
        validation: { required: true }
      },
      image: {
        label: 'Photo of Co-Applicant',
        type: 'file',
        validation: {
          required: true,
          maxSize: 5,
          allowedTypes: ['image/jpeg', 'image/png']
        }
      },
      email: {
        label: 'Email of Co-Applicant',
        type: 'text',
        validation: { email: true, required: true }
      },
      phone: {
        label: 'Phone of Co-Applicant',
        type: 'text',
        validation: { phone: true, required: true }
      }
    }
  },
  directors: {
    title: 'Director',
    details: 'Provide details of the Director.',
    fields: {
      name: {
        label: 'Name of director',
        type: 'text',
        validation: { required: true }
      },
      email: {
        label: 'Email of director',
        type: 'email',
        validation: { required: true }
      },
      phone: {
        label: 'Phone Number of director',
        type: 'tel',
        validation: { required: true }
      },
      pan: {
        label: 'PAN',
        type: 'text',
        pattern: '[A-Z]{5}[0-9]{4}[A-Z]{1}',
        maxLength: 10,
        validation: { required: true }
      },
      image: {
        label: 'Photo of director',
        type: 'file',
        validation: {
          required: true,
          maxSize: 5,
          allowedTypes: ['image/jpeg', 'image/png']
        }
      }
    }
  },
  // Section D: Loan Requirement Details
  sectionD: {
    title: 'Loan Requirements',
    details: 'Provide details for the loan requirements.',
    fields: {
      loanType: {
        label: 'Loan Type',
        type: 'select',
        options: ['Channel Finance', 'Solar Roof Top'],
        validation: { required: true }
      },
      // Channel Finance
      loanRequiredAmountCapitalFinance: {
        label: 'Loan Requirement Amount',
        type: 'number',
        validation: { required: true }
      },
      loanTenureMonthsCapitalFinance: {
        label: 'Loan Tenure (Months)',
        type: 'number'
      },
      detailedReasonCapitalFinance: {
        label: 'Purpose of Loan',
        type: 'text'
      },
      supplier: {
        label: 'Supplier',
        type: 'text'
      },
      bankAccountOfSupplier: {
        label: 'Bank Account of Supplier',
        type: 'text'
      },
      phoneNumberOfSupplier: {
        label: 'Phone No of Supplier',
        type: 'text'
      },
      emailOfSupplier: {
        label: 'Email of Supplier',
        type: 'text'
      },
      // Solar Roof Top Loan
      solarRoofTopLoanAddressOfInstallation: {
        label: 'Solar Roof Top Loan - Address of Installation',
        type: 'text'
      },
      solarRoofTopLoanInstallationPremises: {
        label: 'Installation Premises Type',
        type: 'select',
        options: ['Owned', 'Leased']
      },
      solarRoofTopLoanOwnershipOfPremises: {
        label: 'Solar Roof Top Loan - Ownership of Premises',
        type: 'text'
      },
      nameOfMeterOwner: {
        label: 'Name of Meter Owner',
        type: 'text'
      },
      netMeteringApprovalFromDiscom: {
        label: 'Net Metering Approval from DISCOM',
        type: 'radio',
        options: ['Yes', 'No'],
        validation: { required: true }
      },
      proformaInvoiceNo: {
        label: 'Proforma Invoice No',
        type: 'text'
      },
      proformaInvoiceAmountPanels: {
        label: 'Proforma Invoice Amount',
        type: 'number'
      }
    }
  },

  // Section E: Document Details
  sectionE: {
    title: 'Document Details',
    details:
      'Upload or provide information about the required documents and any other information.',
    fields: {
      incomeTaxReturnsForTheLast2Years: {
        label: 'Income Tax Returns for the Last 2 Years',
        type: 'text'
      },
      moaAoaPartnershipDeedLicenceForProprietorshipConcern: {
        label: 'MOA/AOA/Partnership Deed/License (for Proprietorship Concern)',
        type: 'radio',
        options: ['Yes', 'No']
      },
      financialStatementsForTheLast2Years: {
        label: 'Financial Statements for the Last 2 Years',
        type: 'radio',
        options: ['Yes', 'No']
      },
      bankStatementForTheLast1Year: {
        label: 'Bank Statement for the Last 1 Year',
        type: 'radio',
        options: ['Yes', 'No']
      },
      detailsOfAnyCourtCasesOrClaimsPendingAgainstTheBorrowerImpactingFinancialSoundnessOfTheBorrower:
        {
          label:
            'Details of any Court Cases or Claims Pending Against the Borrower Impacting Financial Soundness of the Borrower',
          type: 'text'
        },
      listOfShareholdersPartnersMembers: {
        label: 'List of Shareholders/Partners/Members',
        type: 'text' // need to change: select from list of options
      },
      applicationPlace: {
        label: 'Place of Application',
        type: 'text'
      }
    }
  },
  // Section F : Guarantor/Co-borrower
  sectionF: {
    title: 'Guarantor/co-borrower',
    details: 'Provide information of Guarantor/co-borrower.',
    fields: {
      nameOfGuarantorCoborrower: {
        label: 'Name of Guarantor/co-borrower',
        type: 'text'
      },
      fathersNameOfGuarantorCoborrower: {
        label: 'Fathers Name of Guarantor/co-borrower',
        type: 'text'
      },
      addressOfGuarantorCoborrower: {
        label: 'Address of Guarantor/co-borrower',
        type: 'textarea'
      },
      panNumberOfGuarantorCoborrower: {
        label: 'PAN Number of Guarantor/co-borrower',
        type: 'text'
      },
      aadhaarOfGuarantorCoborrower: {
        label: 'Aadhaar of Guarantor/co-borrower',
        type: 'number'
      }
    }
  },

  // Section H: Security Offered; A- Solar Rooftop Commercial & Industrial; B- Dealer Finance
  sectionH: {
    title: 'Security Offered',
    details: 'Solar Rooftop Commercial & Industrial',
    fields: {
      solarRooftopCommercialInstitutional: {
        label: 'Solar Rooftop Commercial & Industrial',
        type: 'radio',
        options: ['Yes', 'No']
      },
      hypothecationOfAsset: {
        label: 'Hypothecation of Asset',
        type: 'radio',
        options: ['Yes', 'No']
      },
      personalGuaranteeOfPromoterDirectors: {
        label: 'Personal Guarantee of Promoter Directors',
        type: 'radio',
        options: ['Yes', 'No']
      },
      guaranteeFromEpcContractor: {
        label: 'Guarantee from EPC Contractor',
        type: 'radio',
        options: ['Yes', 'No']
      },
      dealerFinance: {
        label: 'Dealer Finance',
        type: 'radio',
        options: ['Yes', 'No']
      },
      hypothecationOfStock: {
        label: 'Hypothecation of Stock',
        type: 'radio',
        options: ['Yes', 'No']
      },
      comfortLetterFromWaareeSolarManufacturer: {
        label: 'Comfort Letter from Waaree/Solar Manufacturer',
        type: 'radio',
        options: ['Yes', 'No']
      }
    }
  }
};

export const allowedPaths = [
  '/distributor/join',
  '/epc-onboarding',
  '/dsa',
  '/epc-partners'
];

export const registerTabsEnums = [
  {
    enum: 'REGISTRATION_TYPE',
    name: 'Registration Type',
    step: 1
  },
  // {
  //   enum: 'SOLFIN_OFFERS',
  //   name: 'Solfin Offers'
  // },
  {
    enum: 'PROJECT_DETAILS',
    name: 'Project Details',
    step: 2
  },
  {
    enum: 'GST_DETAILS',
    name: 'GST Details',
    step: 3
  },
  {
    enum: 'ITR_DETAILS',
    name: 'ITR Details',
    step: 4
  },
  {
    enum: 'BANK_STATEMENT',
    name: 'Bank Statement',
    step: 5
  },
  {
    enum: 'COMPANY_DOCUMENTS',
    name: 'Company Documents',
    step: 6
  }
];

export const phoneSchema = string()
  .required('Mobile number is required')
  .test('is-valid-indian-phone', 'Invalid Indian mobile number', (value) => {
    // Remove all non-digit characters (e.g., +, -, spaces)
    const cleanedValue = value.replace(/\D/g, '');

    // Check for valid Indian mobile number formats:
    // 1. 10-digit number (e.g., 9084301894)
    // 2. 11-digit number starting with 0 (e.g., 09084301894)
    // 3. 12-digit number starting with 91 (e.g., 919084301894)
    // 4. 13-digit number starting with +91 (e.g., +919084301894)
    if (
      /^\d{10}$/.test(cleanedValue) || // 10 digits
      /^0\d{10}$/.test(cleanedValue) || // 11 digits starting with 0
      /^91\d{10}$/.test(cleanedValue) || // 12 digits starting with 91
      /^\+91\d{10}$/.test(cleanedValue) // 13 digits starting with +91
    ) {
      return true;
    }

    return false;
  });

export const submitButton = {
  width: { md: 'auto', xs: '100%' }
};

export const BANK_NAME_MAP = {
  // Public sector banks
  SBIN: 'State Bank of India',
  PUNB: 'Punjab National Bank',
  BARB: 'Bank of Baroda',
  BKID: 'Bank of India',
  MAHB: 'Bank of Maharashtra',
  CBIN: 'Central Bank of India',
  CNRB: 'Canara Bank',
  HDFC: 'HDFC Bank',
  ICIC: 'ICICI Bank',
  IDIB: 'Indian Bank',
  IOBA: 'Indian Overseas Bank',
  UBIN: 'Union Bank of India',
  UCOB: 'UCO Bank',
  AXIS: 'Axis Bank', // Axis Bank uses UTIB prefix (former UTI Bank)&#8203;:contentReference[oaicite:16]{index=16}
  UTIB: 'Axis Bank',
  ORBC: 'Oriental Bank of Commerce', // (merged into PNB, legacy)
  UBI: 'United Bank of India', // (merged into PNB, legacy)
  PSIB: 'Punjab & Sind Bank',

  // Private sector banks
  KKBK: 'Kotak Mahindra Bank',
  RATN: 'RBL Bank (Ratnakar Bank)',
  FEDB: 'Federal Bank',
  YESB: 'Yes Bank',
  CIUB: 'City Union Bank',
  INDB: 'IndusInd Bank',
  KVBL: 'Karur Vysya Bank',
  KARB: 'Karnataka Bank',
  DLXB: 'Dhanlaxmi Bank',
  CSBK: 'Catholic Syrian Bank',
  TMBL: 'Tamilnad Mercantile Bank',
  LAVB: 'Laxmi Vilas Bank',
  ISEC: 'ICICI Securities Ltd',
  // Foreign banks in India
  BARC: 'Barclays Bank PLC',
  BNPA: 'BNP Paribas',
  BOFA: 'Bank of America',
  CITI: 'Citi Bank N.A.',
  SOFO: 'Societe Generale',

  // Cooperative banks (examples)
  ABHY: 'Abhyudaya Co-op Bank Ltd',
  BCBM: 'Bharat Co-operative Bank Ltd',
  HGBK: 'Hindu Cooperative Bank Ltd',
  BCBL: 'Bassein Catholic Co-op Bank Ltd',

  // Small finance banks
  AUBL: 'AU Small Finance Bank Ltd',
  UJFB: 'Ujjivan Small Finance Bank Ltd',
  ESFB: 'Equitas Small Finance Bank Ltd',
  FCLM: 'Fincare Small Finance Bank Ltd',
  JSFB: 'Jana Small Finance Bank Ltd',
  SRYD: 'Suryoday Small Finance Bank Ltd',
  UTKS: 'Utkarsh Small Finance Bank Ltd',
  SHIV: 'Shivalik Small Finance Bank Ltd',

  // Payment banks
  ALPB: 'Airtel Payments Bank',
  FINO: 'Fino Payments Bank',
  JEBL: 'Jio Payments Bank Ltd',
  PPBL: 'Paytm Payments Bank Ltd',
  IINB: 'India Post Payments Bank',

  // Regional Rural Banks (examples)
  SGBP: 'Sarva UP Gramin Bank',
  ACKB: 'Allahabad UP Gramin Bank',
  VJGB: 'Vidharbha Konkan Gramin Bank',
  APGB: 'Andhra Pragathi Grameena Bank',
  SBGB: 'Saptagiri Grameena Bank'
};

export const QUERY_TYPE_CONFIG = {
  EMI_RELATED: { color: 'primary', label: 'EMI Related' },
  DISBURSEMENT_RELATED: { color: 'warning', label: 'Disbursement Related' },
  SOLAR_PROJECT_RELATED: { color: 'success', label: 'Solar Project Related' },
  APPLICATION_QUERY: { color: 'info', label: 'Application Query' },
  TECHNICAL_ISSUE: { color: 'error', label: 'Technical Issue' },
  APPLICATION_SUPPORT: { color: 'secondary', label: 'Application Support' },
  PAYMENT_QUERY: { color: 'secondary', label: 'Payment Query' },
  GENERAL_INQUIRY: { color: 'process', label: 'General Inquiry' },
  OTHER: { color: 'default', label: 'Other' }
};

export const STATUS_CONFIG = {
  PENDING: { color: 'error', label: 'Pending' },
  IN_PROGRESS: { color: 'warning', label: 'In Progress' },
  COMPLETED: { color: 'success', label: 'Completed' },
  CANCELLED: { color: 'error', label: 'Cancelled' },
  SOLVED: { color: 'info.main', label: 'Solved' }
};

export const USER_TYPE_CONFIG = {
  CUSTOMER: { color: 'success', label: 'Customer' },
  PARTNER: { color: 'progress', label: 'EPC' }
};

export const PRIORITY_CONFIG = {
  HIGH: { color: 'error', label: 'Highest' },
  MEDIUM: { color: 'warning', label: 'Medium' },
  LOW: { color: 'default', label: 'Low' }
};

export const headers = {
  partners: {
    title: 'Partners',
    routePath: '/',
    subroutes: [
      {
        title: 'EPC Partners',
        routePath: '/epc-partners'
      },
      {
        title: 'EPC Rewards',
        routePath: '/epc-rewards'
      },
      {
        title: 'DSA Partners',
        routePath: '/dsa'
      }
    ]
  }
};
export const mainDomain = process.env.REACT_APP_DOMAIN || '';
